import { ActionIcon, Button, Group, Modal, Stack, Text } from '@mantine/core';
import { IconDownload } from '@tabler/icons-react';
import { PromiseDialogFactory, RenderModal } from '../PromiseDialogFactory';
import { useSendResult } from '#/components/ui/messages/endpoints/sendResult';

type SendResultModalData = void;
type SendResultModalProps = { templateId: string };

type TSendResultModal = RenderModal<SendResultModalData, SendResultModalProps>;

const SendResultModal: TSendResultModal = ({
  onCancel,
  isOpen,
  templateId,
}) => {
  const { data } = useSendResult(isOpen, templateId);

  const sentCount = data?.sentCount;
  const processingCount = data?.totalCount;
  const failedCount = data?.errorCount;

  const handleDownloadSent = data?.errorListUri
    ? () => {
        if (data?.errorListUri) {
          window.open(data?.errorListUri, '_blank');
        }
      }
    : undefined;
  const handleDownloadFailed = () => {};

  const rows: {
    label: string;
    count: number | undefined;
    onDownload?: () => void;
  }[] = [
    { label: '已發送', count: sentCount, onDownload: handleDownloadSent },
    { label: '發送處理中', count: processingCount },
    { label: '發送失敗', count: failedCount, onDownload: handleDownloadFailed },
  ];

  return (
    <Modal
      opened={isOpen}
      onClose={() => onCancel?.()}
      title="發送結果"
      centered
      size="lg"
    >
      <Stack gap={0}>
        <Group
          py="md"
          style={{ borderBottom: '1px solid var(--mantine-color-gray-3)' }}
        >
          <Text c="dimmed" w={200}>
            狀態
          </Text>
          <Text c="dimmed" style={{ flex: 1 }}>
            發送人數
          </Text>
        </Group>
        {rows.map((row) => (
          <Group
            key={row.label}
            py="md"
            style={{ borderBottom: '1px solid var(--mantine-color-gray-3)' }}
          >
            <Text w={200}>{row.label}</Text>
            <Group gap="xs" style={{ flex: 1 }}>
              <Text>{row.count ? row.count.toLocaleString() : '-'}</Text>
              {row.onDownload && (
                <ActionIcon
                  variant="light"
                  onClick={row.onDownload}
                  aria-label={`下載 ${row.label}`}
                >
                  <IconDownload size={16} />
                </ActionIcon>
              )}
            </Group>
          </Group>
        ))}
      </Stack>
      <Group mt="xl" justify="flex-end">
        <Button onClick={() => onCancel?.()}>關閉</Button>
      </Group>
    </Modal>
  );
};

const { useModal: usePromiseSendResultModal, Modal: PromiseSendResultModal } =
  PromiseDialogFactory(SendResultModal);

export { PromiseSendResultModal, usePromiseSendResultModal };
